import axios from 'axios';
import { IFreshServiceTicketUpsert } from '../../../@types/model/freshService/freshServiceTicketModels';

export default class FreshHttpService {
    public static createTicket = async (upsert : IFreshServiceTicketUpsert) : Promise<void> => {
        await axios.post(`${API_URL}/v1/FreshService/CreateTicket`, upsert);
    }
}
